// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1HRDt","buttons":"PendingPaymentAlert_buttons__2Vf8T"};